
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Les KPI essentiels pour booster vos campagnes Facebook Ads",
    description:
      "Découvrez les KPI indispensables pour mesurer et optimiser rapidement vos campagnes Facebook Ads. Analysez vos résultats avec les conseils de vos experts ALEO.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
